import { z } from "zod";
import { parseCatalogEntityPayload } from "@/lib/toolCardSchemas/parseCatalogEntityPayload";

export const SourcesPayloadSchema = z.object({
  projectPublicId: z.string(),
  conversationPublicId: z.string(),
  title: z.string().optional(),
  description: z.string().optional(),
});

export const SourcesResolveSchema = z.object({
  skipped: z.boolean().optional(),
  documentPublicIds: z.array(z.string()).optional(),
  insightPublicIds: z.array(z.string()).optional(),
  experimentPublicIds: z.array(z.string()).optional(),
});

export type SourcesArgs = z.infer<typeof SourcesPayloadSchema>;
export type SourcesToolResult = z.infer<typeof SourcesResolveSchema>;

/**
 * Parses sources card payload from flat args or entities[] agent shape.
 */
export function parseSourcesPayload(args: unknown, toolCallId?: string) {
  return parseCatalogEntityPayload(SourcesPayloadSchema, "sources", args, toolCallId, (entity) => ({
    projectPublicId: entity.projectPublicId,
    conversationPublicId: entity.conversationPublicId,
    title: entity.title,
    description: entity.description,
  }));
}
